<app-modal-content-confirm
  title="Split Record"
  questionText="How many hours would you like to split?"
  yesText="Split"
  noText="Cancel"
  [isDisabled]="formCtrl.invalid"
  (closed)="handlePromptClicked($event)"
>
  <div class="mt-8 flex flex-col items-center justify-center gap-8">
    <span>Available Hours: {{ pool }}</span>
    <mat-form-field>
      <mat-label>Hours To Split</mat-label>
      <input matInput type="number" [formControl]="formCtrl" />
      @if (formCtrl.hasError('required')) {
        <mat-error>This is required</mat-error>
      }
      @if (formCtrl.hasError('min')) {
        <mat-error>Must be greater than 0</mat-error>
      }
      @if (formCtrl.hasError('greaterThanOrEqualTo')) {
        <mat-error>Must be less than the total</mat-error>
      }
    </mat-form-field>
  </div>
</app-modal-content-confirm>
